module.exports = __webpack_public_path__ + "img/development.34dd08b6.jpg";